export default __webpack_public_path__ + "static/media/style2.c1ea9298.jpg";